import React, { useEffect, useState } from 'react';
import intl from 'react-intl-universal';
import { SelectBox } from 'components/uikit-adapter';
import {
  ModalText,
  ModalTitle,
  WrapperButtons,
  WrapperContent,
} from './styled';
import Button from 'components/button';
import GenericModal from 'components/generic-modal';

export enum ModalType {
  Information = 'Information',
  Danger = 'Danger',
}

interface Justification {
  Key: number;
  Value: string;
}

interface ConfirmationJustificationDialogProps {
  show: boolean;
  title: string;
  description?: string;
  justifications: Justification[];
  labelButton: string;
  labelButtonClose: string;
  handleConfirm: (justification: number) => void;
  handleClose: () => void;
  isLoading?: boolean;
  modalType?: ModalType;
}

const ConfirmationJustificationDialog: React.FC<ConfirmationJustificationDialogProps> = ({
  show,
  title,
  description,
  justifications,
  labelButton,
  labelButtonClose,
  handleConfirm,
  handleClose,
  isLoading,
  modalType = ModalType.Information,
}) => {
  const [open, setOpen] = useState(show);
  const [selectedJustification, setSelectedJustification] = useState<number>(0);
  const [messageError, setMessageError] = useState<string>('Selecione uma Justificativa');

  useEffect(() => {
    setOpen(show);
  }, [show]);

  useEffect(() => {
    if (show) {
      ensureDefaultSelectedJustification(justifications);
    }
  }, [show, justifications]);

  const ensureDefaultSelectedJustification = (justifications: Justification[]) => {
    if (justifications && justifications.length > 0) {
      setSelectedJustification(justifications[0].Key);
    } else {
      setSelectedJustification(0);
    }
  };

  const onRequestClose = () => {
    setOpen(false);
    handleClose();
  };

  const onClick = () => {
    if (!selectedJustification) {
      setMessageError('Selecione uma Justificativa');
      return;
    }
    handleConfirm(selectedJustification);
    onRequestClose();
  };

  const onCancelClick = () => {
    setSelectedJustification(0);
    handleClose();
  };

  const onChange = (value: Justification) => {
    setSelectedJustification(value.Key);
    setMessageError('');
  };

  return (
    <GenericModal open={open} onRequestClose={onRequestClose}>
      <WrapperContent>
        <ModalTitle modalType={modalType}>{title}</ModalTitle>

        {description && <ModalText>{description}</ModalText>}

        <ModalText>
          {intl.get('stocks.suggestionsListItem.justification')}
        </ModalText>
        <SelectBox
          required
          name="justifications"
          className="justifications-selectbox"
          valueKey="Key"
          labelKey="Value"
          value={selectedJustification}
          options={justifications}
          onChange={onChange}
          openOnFocus
          placeholder={intl.get(
            'load-building.page-flow.modal-justification.placeholder'
          )}
          data-testid="selectbox-justification"
          disabled={isLoading}
        />
        {messageError && !selectedJustification && (
          <ModalText style={{ color: 'red' }}>{messageError}</ModalText>
        )}
      </WrapperContent>
      <WrapperButtons modalType={modalType}>
        <Button
          value={labelButtonClose}
          buttonType="tertiary"
          onClick={onCancelClick}
          className="btn"
          style={{ width: '150px' }}
          data-testid="close-btn"
        />
        <Button
          value={labelButton}
          buttonType="primary"
          onClick={onClick}
          className={`btn margin-botao${modalType === ModalType.Danger ? ' danger-btn' : ''}`}
          style={{ width: '150px' }}
          data-testid="confirm-btn"
          disabled={isLoading}
        />
      </WrapperButtons>
    </GenericModal>
  );
};

export default ConfirmationJustificationDialog;